<template>
  <section class="login-wrapper">
    <section class="material-half-bg">
      <div class="cover"></div>
    </section>
    <section class="container mt-4">
      <h2 class="text-center">
        รายการบันทึกการตรวจสอบ <b class="text-danger">ถังดับเพลิง </b>
      </h2>
      <h3 class="text-center mb-4">#{{ code }}</h3>

      <div class="text-center">
        <button
          class="btn btn-warning border-dark btn-lg mb-3"
          @click="openFormModal"
        >
          เพิ่มบันทึกการตรวจสอบ
        </button>
      </div>

      <div class="card mb-3">
        <div class="card-body">
          <!-- <div v-if="!filteredRecords.length" class="d-flex justify-content-center align-items-center">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div> -->
          <form class="d-md-inline-block form-inline ms-auto me-0 me-md-3 mb-3">
            <div class="input-group">
              <select v-model="selectedMonth" class="form-select" required>
                <option value="" disabled>- เลือกเดือน -</option>
                <option
                  v-for="month in months"
                  :key="month.value"
                  :value="month.value"
                >
                  {{ month.name }}
                </option>
              </select>

              <select v-model="selectedYear" class="form-select ms-2" required>
                <option value="" disabled>- เลือกปี -</option>
                <option v-for="year in years" :key="year" :value="year">
                  {{ year + 543 }}
                </option>
              </select>

              <button
                @click.prevent="clearFilters"
                class="btn btn-secondary"
                type="button"
              >
                <i class="bi bi-arrow-clockwise"></i> รีเซ็ต
              </button>
            </div>
          </form>

          <div class="position-relative">
            <LoadingOverlay :show="loading" />
            <div class="table-responsive">
              <table class="table table-bordered table-striped">
                <thead class="table-dark text-center">
                  <tr>
                    <th>วันเวลาที่บันทึก</th>
                    <th>ชื่อผู้บันทึก</th>
                    <th>หน่วยงาน</th>
                    <th>รหัส-ชื่อ</th>
                    <th>รายการตรวจเช็ค</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="!filteredRecords.length">
                    <td class="text-center text-muted" colspan="5">No data</td>
                  </tr>
                  <tr v-for="record in filteredRecords" :key="record.id">
                    <td>
                      {{ formatThaiDate(record.record_date) }}
                      {{ record.record_time }}
                    </td>
                    <td>{{ record.recorder }}</td>
                    <td>{{ record.group?.name }}</td>
                    <td>
                      {{ record.fire_extinguisher.code }} -
                      {{ record.fire_extinguisher.name }}
                    </td>
                    <td>
                      <ul>
                        <!-- <li v-for="item in record.items" :key="item.id">
                        {{ item.name }} - <span :class="item.pivot.status ? 'text-success' : 'text-danger'">
                          {{ item.pivot.status ? '✅' : '❌' }}
                        </span>
                      </li> -->
                        <li
                          v-for="masterItem in fireExtinguisherItems"
                          :key="masterItem.id"
                        >
                          {{ masterItem.name }} -

                          <span
                            :class="
                              hasItem(record.items, masterItem.id)
                                ? 'text-success'
                                : 'text-danger'
                            "
                          >
                            {{
                              hasItem(record.items, masterItem.id) ? "✅" : "❌"
                            }}
                          </span>
                        </li>
                      </ul>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal for inserting form data -->
      <div
        class="modal fade"
        id="Modal"
        tabindex="-1"
        data-bs-backdrop="static"
        aria-labelledby="roleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">บันทึกการตรวจสอบ ถังดับเพลิง</h5>
              <button
                type="button"
                class="btn-close"
                @click="closeFormModal"
              ></button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="handleSubmit">
                <div class="row" v-if="showRecordDateTime">
                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label"
                        >วันที่บันทึก (Record Date)</label
                      >
                      <DatePicker v-model="form.record_date" />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label">เวลา (Record Time)</label>
                      <TimePicker v-model="form.record_time" required />
                    </div>
                  </div>
                </div>

                <div class="mb-3">
                  <label class="form-label">หน่วยงาน (Department)</label>
                  <select
                    disabled
                    v-model="form.group_id"
                    class="form-select"
                    required
                  >
                    <option value="">- เลือกหน่วยงาน -</option>
                    <option
                      v-for="group in groups"
                      :key="group.id"
                      :value="group.id"
                    >
                      {{ group.name }}
                    </option>
                  </select>
                </div>

                <!-- <div class="mb-3">
                  <label class="form-label">Fire Extinguisher</label>
                  <select v-model="form.fire_extinguisher_id" class="form-select" required>
                    <option value="">Select Fire Extinguisher</option>
                    <option v-for="extinguisher in fireExtinguishers" :key="extinguisher.id" :value="extinguisher.id">
                      {{ extinguisher.name }} ({{ extinguisher.code }})
                    </option>
                  </select>
                </div> -->

                <div class="mb-3">
                  <label class="form-label">รายการตรวจเช็ค (Checklists)</label>
                  <div
                    class="form-check"
                    v-for="item in fireExtinguisherItems"
                    :key="item.id"
                  >
                    <input
                      type="checkbox"
                      class="form-check-input"
                      :id="'item-' + item.id"
                      :value="{ id: item.id, status: true }"
                      v-model="form.items"
                    />
                    <label class="form-check-label" :for="'item-' + item.id">{{
                      item.name
                    }}</label>
                  </div>
                </div>

                <!-- <div class="mb-3">
                  <label class="form-label">Recorder</label>
                  <input v-model="form.recorder" type="text" class="form-control" required />
                </div> -->

                <div class="mb-3">
                  <label class="form-label">ชื่อผู้บันทึก (Recorder)</label>
                  <v-select
                    v-model="form.recorder"
                    :options="doctors"
                    label="name"
                    :reduce="(item) => item.name"
                    :clearable="false"
                    placeholder="ค้นหา..ชื่อผู้บันทึก"
                  >
                    <template #search="{ attributes, events }">
                      <input
                        class="vs__search"
                        :required="!form.recorder"
                        v-bind="attributes"
                        v-on="events"
                      />
                    </template>
                  </v-select>
                </div>

                <hr />
                <button type="submit" class="btn btn-lg btn-primary w-100">
                  บันทึกข้อมูล (Save)
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import axiosInstance from "@/utils/axiosInstance";
import { showErrorAlert, showSuccessAlert } from "@/utils/sweetalert2-utils";
// import { formatDateTime } from '@/utils/dateUtils';
// import ChartMedicineCabinet from '@/components/ChartMedicineCabinet.vue';
import axios from "axios";
import { useRoute } from "vue-router";
import { Modal } from "bootstrap";
import Swal from "sweetalert2";
import moment from "moment";
import DatePicker from "@/components/DatePicker.vue";
import TimePicker from "@/components/TimePicker.vue";
import LoadingOverlay from "@/components/LoadingOverlay.vue";
import { useShowRecordDateTime } from "@/utils/recordSettings";

const { showRecordDateTime } = useShowRecordDateTime();

const modal = ref(null);
// const records = ref([]);
const fireExtinguisherItems = ref([]);
// const isModalOpen = ref(false);
const now = moment();

const form = ref({
  recorder: "",
  group_id: "",
  fire_extinguisher_id: "",
  items: [],
  record_date: now.format("YYYY-MM-DD"),
  record_time: now.format("HH:mm:ss"),
});
const groups = ref([]);
// const compartmentTypes = ref([]);
// const shiftTypes = ref([]);
const doctors = ref([]);
const route = useRoute();
const code = ref(route.params.code);
const chartKey = ref(0); // Added key to trigger chart re-render
const fireExtinguisherRecords = ref([]);
const fireExtinguishers = ref([]);
const loading = ref(false);

const months = [
  { value: 1, name: "มกราคม" },
  { value: 2, name: "กุมภาพันธ์" },
  { value: 3, name: "มีนาคม" },
  { value: 4, name: "เมษายน" },
  { value: 5, name: "พฤษภาคม" },
  { value: 6, name: "มิถุนายน" },
  { value: 7, name: "กรกฎาคม" },
  { value: 8, name: "สิงหาคม" },
  { value: 9, name: "กันยายน" },
  { value: 10, name: "ตุลาคม" },
  { value: 11, name: "พฤศจิกายน" },
  { value: 12, name: "ธันวาคม" },
];

// function formatDateTimeUTC(date) {
//   return moment.utc(date) // ⬅️ ใช้ UTC
//     .locale('th')         // ภาษาไทย
//     .format('DD MMM YYYY HH:mm:ss') // แสดงเวลาแบบไม่แปลง
//     .replace(`${moment.utc(date).year()}`, `${moment.utc(date).year() + 543}`); // แปลงปีเป็น พ.ศ.
// }
function formatThaiDate(date) {
  const m = moment(date).locale("th");
  return m.format("D MMM YYYY").replace(m.year(), m.year() + 543);
}

const selectedMonth = ref(new Date().getMonth() + 1);
const selectedYear = ref(new Date().getFullYear());

const currentYear = new Date().getFullYear();
const years = Array.from({ length: 3 }, (_, i) => currentYear - i); // 5 ปีย้อนหลัง

const filteredRecords = computed(() => {
  return fireExtinguisherRecords.value
    .filter((record) => {
      const recordDate = moment(record.record_date, "YYYY-MM-DD");
      return (
        record.fire_extinguisher.code === code.value &&
        recordDate.month() + 1 === Number(selectedMonth.value) &&
        recordDate.year() === Number(selectedYear.value)
      );
    })
    .sort((a, b) => {
      const dateA = `${a.record_date} ${a.record_time || "00:00:00"}`;
      const dateB = `${b.record_date} ${b.record_time || "00:00:00"}`;
      return dateA.localeCompare(dateB);
    });
});

const hasItem = (items, itemId) => {
  return items.some((i) => i.id === itemId && i.pivot?.status);
};

const fetchDataCode = async () => {
  try {
    const response = await axiosInstance.get(
      `/check_fire_extinguisher/${code.value}`
    );
    form.value.group_id = response.data.group_id;
    form.value.fire_extinguisher_id = response.data.id;
    // form.value.recorder = '';
    // // form.value.tank_number = '1';
    // form.value.inspect_spray_nozzle = false
    // form.value.inspect_control_lever = false
    // form.value.inspect_body = false
    // form.value.inspect_pressure_gauge_weight = false
    fetchData(response.data.id);
  } catch (error) {
    showErrorAlert("ไม่สามารถโหลดข้อมูลได้");
  }
};

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.onmouseenter = Swal.stopTimer;
    toast.onmouseleave = Swal.resumeTimer;
  },
});

const fetchData = async (id) => {
  loading.value = true;
  try {
    const [recordsRes, extinguishersRes, itemsRes, groupsRes] =
      await Promise.all([
        axiosInstance.get("fire_extinguisher_record/extinguisher/" + id),
        axiosInstance.get("fire_extinguisher"),
        axiosInstance.get("fire_extinguisher_item"),
        axiosInstance.get("group"),
      ]);

    fireExtinguisherRecords.value = recordsRes.data;
    fireExtinguishers.value = extinguishersRes.data;
    fireExtinguisherItems.value = itemsRes.data;
    groups.value = groupsRes.data;

    // Get the current month and year in 'YYYY-MM' format
    const currentMonth = moment().format("YYYY-MM");

    // Check if any record has record_date within the current month
    const thisMonthRecord = recordsRes.data.some((record) => {
      const recordMonth = moment(record.record_date, "YYYY-MM-DD").format(
        "YYYY-MM"
      );
      // return createdAtMonth === currentMonth;
      // console.log(record.fire_extinguisher.code);
      return (
        recordMonth === currentMonth &&
        record.fire_extinguisher.code === code.value
      );
    });

    // Show notification based on whether there is a record this month
    if (thisMonthRecord) {
      Toast.fire({
        icon: "success",
        title: "มีการบันทึกข้อมูลในเดือนนี้!",
      });
    } else {
      Toast.fire({
        icon: "error",
        title: "ยังไม่บันทึกข้อมูลในเดือนนี้!",
      });
    }
  } catch (error) {
    showErrorAlert("ไม่สามารถโหลดข้อมูลได้");
  } finally {
    loading.value = false;
  }

  //   // Get the current date in 'YYYY-MM-DD' format
  //   const currentDate = new Date().toISOString().split('T')[0];

  //   // Check if any record has record_date matching the current date
  //   const todayRecord = recordsRes.data.find(record => {
  //     const createdAtDate = new Date(record.record_date).toISOString().split('T')[0];
  //     return createdAtDate === currentDate;
  //   });

  //   // If a record with today's date is found, show the notification
  //   if (todayRecord) {
  //     Toast.fire({
  //       icon: "success",
  //       title: "บันทึกแล้ว ในวันนี้!"
  //     });
  //   } else {
  //     Toast.fire({
  //       icon: "error",
  //       title: "ยังไม่บันทึกแล้ว ในวันนี้!"
  //     });
  //   }
  // } catch (error) {
  //   showErrorAlert('ไม่สามารถโหลดข้อมูลได้');
  // }
};

// const filteredRecords = computed(() => {
//   return fireExtinguisherRecords.value.filter(record =>
//     record.fire_extinguisher_id === Number(form.value.fire_extinguisher_id)
//   );
// });

const getDoctors = async () => {
  try {
    const res = await axios.get(
      "https://api-hos.wanorn.com/backend/api/doctor"
    );
    // doctors.value = res.data;
    doctors.value = res.data.filter((doctor) => doctor.active !== "N");
  } catch (error) {
    showErrorAlert("ไม่สามารถโหลดข้อมูลได้");
  }
};

const handleSubmit = async () => {
  try {
    await axiosInstance.post("/fire_extinguisher_record", form.value);
    showSuccessAlert("บันทึกเรียบร้อยแล้ว!");
    // fetchData();
    fetchDataCode();
    hideModal();
    chartKey.value += 1; // Change the key to force re-render
  } catch (error) {
    console.log(error);
    showErrorAlert("เกิดข้อผิดพลาดในการบันทึกข้อมูล");
  }
};

const showModal = () => modal.value.show();
const hideModal = () => modal.value.hide();

const openFormModal = () => {
  const now = moment(); // ✅ use moment() instead of new Date()
  form.value.record_date = now.format("YYYY-MM-DD");
  form.value.record_time = now.format("HH:mm:ss"); // includes seconds as required

  showModal();
};

const closeFormModal = () => {
  hideModal();
  const now = moment();
  form.value = {
    recorder: "",
    group_id: form.value.group_id,
    fire_extinguisher_id: form.value.fire_extinguisher_id,
    items: [],
    record_date: now.format("YYYY-MM-DD"),
    record_time: now.format("HH:mm:ss"),
  };
};

onMounted(() => {
  // fetchData();
  // fetchDropdownData();
  getDoctors();
  fetchDataCode();
  modal.value = new Modal(document.getElementById("Modal"));
});
</script>

<style scoped>
.login-wrapper {
  display: flex;
  height: 100vh;
}

.material-half-bg {
  flex: 1;
}

.login-content {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* .card {
  width: 100%;
  max-width: 500px;
  padding: 20px;
} */
.cover {
  background: url("https://media.istockphoto.com/id/1327086620/th/%E0%B8%A3%E0%B8%B9%E0%B8%9B%E0%B8%96%E0%B9%88%E0%B8%B2%E0%B8%A2/%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B9%83%E0%B8%8A%E0%B9%89%E0%B8%96%E0%B8%B1%E0%B8%87%E0%B8%94%E0%B8%B1%E0%B8%9A%E0%B9%80%E0%B8%9E%E0%B8%A5%E0%B8%B4%E0%B8%87.jpg?s=612x612&w=0&k=20&c=JrnO9xg1b71oTb00vXwEzuWdbGOGzBwJgurm5EMw498=")
    no-repeat center center;
  background-size: cover;
  height: 100%;
  opacity: 0.3;
  /* Adjust opacity value as needed */
}
</style>
